<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('from_label_chaxunch') ||
                  '用户账号/中文姓名/英文姓名/手机号码/邮件地址/业务角色/所属机构/所属部门搜索……'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <div class="drop" v-if="allow('I')">
              <el-dropdown
                size="small"
                split-button
                @click="$emit('openImportDialog')"
                @command="openImportTemplate"
                class="ml-2"
              >
                <b-icon icon="cloud-upload" />
                {{ $l('INDEX.btn_import') || '导入' }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="download">
                    {{ $l('btn_download_template') || '下载模版' }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_user_status') || '用户状态'">
              <el-checkbox-group v-model="form.userStatusList">
                <el-checkbox label="Y" name="type">{{
                  this.$l('INDEX.form_label_valid') || '有效'
                }}</el-checkbox>
                <el-checkbox label="N" name="type">{{
                  this.$l('INDEX.form_label_invalid') || '无效'
                }}</el-checkbox>
                <el-checkbox label="S" name="type">{{
                  this.$l('form_label_deactivate') || '停用'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_chinese_name') || '中文姓名'">
              <el-input
                v-model.trim="form.userName"
                maxlength="100"
                :placeholder="
                  $l('form_label_please_chinese_name') || '请输入中文姓名'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_english_name') || '英文姓名'">
              <el-input
                v-model.trim="form.userNameEn"
                maxlength="100"
                :placeholder="
                  $l('form_label_please_chinese_name') || '请输入英文姓名'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('from_radio_phone_number') || '手机号码'">
              <el-input
                v-model.trim="form.mobileNumber"
                maxlength="100"
                :placeholder="
                  $l('from_label_Please_phone_number') || '请输入手机号码'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('from_radio_mailing_address') || '邮件地址'"
            >
              <el-input
                v-model.trim="form.emailAddress"
                maxlength="100"
                :placeholder="
                  $l('from_label_Please_mailing_address') || '请输入邮件地址'
                "
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_business_role') || '业务角色'">
              <dict-select
                clearable
                v-model="form.userJobTypeList"
                :body="userJobTypeParams"
                url="/sys/common/dict/system"
                :placeholder="
                  $l('from_label_Please_business_role') || '请选择业务角色'
                "
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_organization') || '所属机构'">
              <dict-select
                clearable
                v-model="form.orgCodeList"
                :body="orgParams"
                url="/sys/common/dict/orgDict"
                :placeholder="
                  $l('from_label_Please_organization') || '请选择所属机构'
                "
                filterable
                multiple
              >
              </dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('form_label_scope_customer_authority') || '客户权限范围'
              "
            >
              <dict-select
                clearable
                v-model="form.userCustRangeList"
                :body="userCustRangeParams"
                url="/sys/common/dict/system"
                :placeholder="
                  $l('from_label_please_customer_permission_range') ||
                    '请选择对应客户权限范围'
                "
                filterable
                multiple
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="20">
              <el-form-item
                :label="$l('form_label_modification_date') || '修改日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_label_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('form_label_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>

    <ChooseImportTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'admin-user-import' }"
    />
  </div>
</template>

<script>
import ChooseImportTemplate from '@/views/backstage/components/choose-import-template'

// 初始表单
const initForm = {
  searchKey: '',
  userStatusList: ['Y'],
  userJobTypeList: [],
  orgCodeList: [],
  userCustRangeList: [],
}

export default {
  components: { ChooseImportTemplate },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      orgParams: {},
      userJobTypeParams: { dictType: 'userJobType' },
      userCustRangeParams: { dictType: 'userCustRange' },
      chooseTemplateOptions: { visible: false },
    }
  },
  created() {
    this.query()
    this.$eventBus.$on('userSaveSuccess', () => {
      this.query()
    })
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    openImportTemplate() {
      this.chooseTemplateOptions.visible = true
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'system-sysuser-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
::v-deep {
  .drop {
    .el-button {
      border: 1px solid #007bff;
      color: #007bff;
      font-size: 0.875rem;
      border-radius: 3px 0px 0px 3px !important;
    }
    .el-dropdown__caret-button {
      border-left: none;
      border-radius: 0px 3px 3px 0px !important;
    }
    .el-button:hover {
      color: #fff;
      background-color: #007bff;
      border-color: #007bff;
    }
    .el-button--default::before {
      background: #d0d2d6;
    }
    .el-button--small {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
      line-height: 1.5;
    }
  }
}
</style>
